import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { PRIMITIVE_COLORS, SEMANTIC_COLORS } from '@/constants/residents/residentColors';

interface InfoRowProps {
  label: string;
  value: string;
  variant?: 'mobile' | 'desktop';
}

/**
 * InfoRow - Displays a label-value pair for maintenance ticket information
 * Used in both mobile and desktop detail views
 */
export const InfoRow: React.FC<InfoRowProps> = ({ 
  label, 
  value, 
  variant = 'mobile' 
}) => (
  <View style={styles.infoRow}>
    <Text style={variant === 'mobile' ? styles.mobileLabel : styles.desktopLabel}>
      {label}
    </Text>
    <Text style={variant === 'mobile' ? styles.mobileValue : styles.desktopValue}>
      {value}
    </Text>
  </View>
);

const styles = StyleSheet.create({
  infoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  // Mobile styles
  mobileLabel: {
    fontSize: 14,
    fontWeight: '500',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 21,
  },
  mobileValue: {
    fontSize: 14,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textSecondary,
    lineHeight: 21,
    textAlign: 'right',
  },
  // Desktop styles
  desktopLabel: {
    fontSize: 14,
    fontWeight: '500',
    color: SEMANTIC_COLORS.text.primary,
    lineHeight: 21,
  },
  desktopValue: {
    fontSize: 14,
    fontWeight: '400',
    color: PRIMITIVE_COLORS.gray300,
    lineHeight: 21,
    textAlign: 'right',
  },
});
